<template>
  <section>
    <div class="o-page-row">
      <div class="c-carousel-container">
        <flickity class="c-carousel-image js-slider" ref="flickity" v-images-loaded="loaded" :options="sliderOptions">
          <div class="c-carousel-image__slide" v-for="(medium, index) in media">
            <img v-if="medium.type=='image'" class="js-carousel-img preview-img-item" :src="medium.src">
            <div v-if="medium.type=='video'"  class="js-carousel-img preview-img-item">
              <iframe width="470" height="315" :src="'https://www.youtube.com/embed/' + medium.src" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>          
          </div>
        </flickity>

        <span class="c-carousel-image__button c-carousel-image__button_prev" v-show="hasPrevious" @click="previous()"><svgicon class="svg-left" name="arrow-right" width="35" height="35"></svgicon></span>
        <span class="c-carousel-image__button c-carousel-image__button_next" v-show="hasNext" @click="next()"><svgicon name="arrow-right" width="35" height="35"></svgicon></span>
      </div>
      
      <button class="c-button c-button--small c-button--neutral c-button--icon-only u-flex--align-self-start" type="button" @click="openPhotoSwipe">
        <svgicon name="expand" width="1.25em" height="1.25em"></svgicon>
      </button>
    </div>

    <flickity class="c-carousel-thumb js-thumbs" ref="flickity_thumbs" v-images-loaded="loaded" :options="sliderThumbOptions">
      <button type="button" @click="currentSlide = index" class="c-carousel-thumb__slide c-button c-button--reset" v-for="(medium, index) in media">
        <img v-if="medium.type=='image'" :src="medium.src" alt="">
        <div v-if="medium.type=='video'">
          <svgicon name="play" width="25" height="25"></svgicon>
          Video
        </div>
      </button>
    </flickity>

    <!-- Root element of PhotoSwipe. Must have class pswp. -->
    <div class="pswp" tabindex="-1" role="dialog" aria-hidden="true">

      <!-- Background of PhotoSwipe.
           It's a separate element as animating opacity is faster than rgba(). -->
      <div class="pswp__bg"></div>

      <!-- Slides wrapper with overflow:hidden. -->
      <div class="pswp__scroll-wrap">

        <!-- Container that holds slides.
            PhotoSwipe keeps only 3 of them in the DOM to save memory.
            Don't modify these 3 pswp__item elements, data is added later on. -->
        <div class="pswp__container">
          <div class="pswp__item"></div>
          <div class="pswp__item"></div>
          <div class="pswp__item"></div>
        </div>

        <!-- Default (PhotoSwipeUI_Default) interface on top of sliding area. Can be changed. -->
        <div class="pswp__ui pswp__ui--hidden">

          <div class="pswp__top-bar">

            <!--  Controls are self-explanatory. Order can be changed. -->

            <div class="pswp__counter"></div>

            <button class="pswp__button pswp__button--close" title="Close (Esc)"></button>

            <button class="pswp__button pswp__button--share" title="Share"></button>

            <button class="pswp__button pswp__button--fs" title="Toggle fullscreen"></button>

            <button class="pswp__button pswp__button--zoom" title="Zoom in/out"></button>

            <!-- Preloader demo http://codepen.io/dimsemenov/pen/yyBWoR -->
            <!-- element will get class pswp__preloader--active when preloader is running -->
            <div class="pswp__preloader">
              <div class="pswp__preloader__icn">
                <div class="pswp__preloader__cut">
                  <div class="pswp__preloader__donut"></div>
                </div>
              </div>
            </div>
          </div>

          <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">
            <div class="pswp__share-tooltip"></div>
          </div>

          <button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)">
          </button>

          <button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)">
          </button>

          <div class="pswp__caption">
            <div class="pswp__caption__center"></div>
          </div>

        </div>

      </div>

    </div>
  </section>
</template>

<script>
    import Vue from 'vue'
    import Flickity from 'vue-flickity'
    import imagesLoaded from 'vue-images-loaded'
    import PhotoSwipe from 'photoswipe'
    import PhotoSwipeDefaultUI from 'photoswipe/dist/photoswipe-ui-default'
    import 'photoswipe/dist/default-skin/default-skin.css'
    import 'photoswipe/dist/photoswipe.css'

    export default {
        props: {
            media: {type: Array, default:[]}
        },
        directives: {
            imagesLoaded
        },
        components: {
            Flickity
        },
        data () {
            return {
                block: false,
                currentSlide: 0,
                sliderOptions: {
                    initialIndex: 0,
                    prevNextButtons: false,
                    pageDots: false,
                    wrapAround: true,
                    draggable: true,
                    setGallerySize: false,
                },
                sliderThumbOptions: {
                    freeScroll: true,
                    freeScrollFriction: 0.03,
                    contain: true,
                    pageDots: false,
                    prevNextButtons: false,
                },
            }
        },
        computed:{
            photoswipeOptions(){
                return {
                    getThumbBoundsFn: function(index) {
                        const thumbnail = document.querySelectorAll('.js-carousel-img')[index];
                        const pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
                        const rect = thumbnail.getBoundingClientRect();
                        return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
                    },
                    index: this.currentSlide
                }
            }, 
            hasNext() {
              return this.currentSlide < this.media.length - 1;
            },
            hasPrevious() {
              return this.currentSlide > 0;
            }
        },
        mounted () {
            this.$refs.flickity.on('select', () => {
                if (this.block) {
                    this.currentSlide = this.$refs.flickity.selectedIndex()
                } else {
                    this.block = true;
                }
            });
            this.$refs.flickity_thumbs.on('select', () => {
                if (this.block) {
                    this.currentSlide = this.$refs.flickity_thumbs.selectedIndex()
                } else {
                    this.block = true;
                }
            });
        },

        watch: {
            currentSlide () {
                this.block = true;                
                this.$refs.flickity.select(this.currentSlide);
                this.$refs.flickity_thumbs.select(this.currentSlide);
            }
        },

        methods: {
            bindFlickityEvents() {
              this.$refs.flickity_thumbs.on('change', function(index) {
                debugger;
              });
            },
            loaded () {
                Object.keys(this.$refs).forEach((ref) => {
                    this.$refs[ref].resize();
                    this.$refs[ref].rerender();
                })
            },

            PhotoSwipeInstance(){
                return new PhotoSwipe( this.$el.querySelectorAll('.pswp')[0], PhotoSwipeDefaultUI, this.media.filter(x => { return x.type == 'image'}), this.photoswipeOptions);
            },

            openPhotoSwipe() {
                const photoSwipeInstance = this.PhotoSwipeInstance();
                photoSwipeInstance.listen('afterChange', () => {
                    this.currentSlide = photoSwipeInstance.getCurrentIndex();
                });
                photoSwipeInstance.init();
            },

            next() {
              if(this.hasNext){
                this.currentSlide += 1;
              }
            },

            previous() {
              if(this.hasPrevious){
                this.currentSlide -= 1;
              }
            }
        },
    }
</script>

<style lang="scss">

  @import "~@/assets/scss/private";

  .c-carousel-container {
     position: relative;
  }

  .c-carousel-image {
    width: 100%;
    height: 350px;
    align-items: center;

    &__button {
      color:$color-base;

    position: absolute;    
    top: 50%;
    transform: translateY(-50%);

      svg {            
        fill: $color-base;
        color: $color-base;

        &.svg-down {
          transform: translateY(-50%) rotate(90deg);
        }
      }

      svg:hover {
        cursor:pointer;
      }
    }

    &__button_prev {
      left: 0;
    }

    &__button_next {
      right: 0;
    }

    &__slide {
      width: 100%;
      height: 100%;

      top: 0; // IE11 fix
      height: 350px;
      text-align: center;

      @include down($desktop) {
        top: auto;
      }

      img {
        max-height: 100%;
      }
    }
  }

  .c-carousel-thumb {
    height: 60px;
    &__slide {
      width: 100px;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      

      img {
        max-height: 100%;
        height: 100%;
        object-fit: cover;
      }

      div {
        color:$color-base;
      }

      &:not(:last-child) {
        margin-right: em($global-spacing-unit-small);
      }

      &.is-selected {
        border: 1px solid $color-neutral;
      }
    }
  }

  .is-ie11 {
    .c-carousel-thumb .c-carousel-thumb__slide {
      top: 0;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/carousel/Carousel.vue